import React from "react";
import Img1 from "./Images/img1.jpg";      // Daily Wholesale Deals
import Img2 from "./Images/img2.jpg";       // Effortless Bulk Ordering
import Img3 from "./Images/img3.jpg";   // Smart Purchase Insights
import Img4 from "./Images/img4.jpg";    // Real-Time Seller Support

const FeaturesSection = () => {
  const features = [
    {
      img: Img1,
      title: "Daily Wholesale Deals",
      desc: "Get fresh bulk offers every day across groceries, stationery, and essentials—exclusively deals.",
    },
    {
      img: Img2,
      title: "Effortless Bulk Ordering",
      desc: "Place, track, and manage your large orders with a clean, user-friendly interface that keeps things simple.",
    },
    {
      img: Img3,
      title: "Smart Purchase Insights",
      desc: "Track spending, reorder popular items, and analyze buying patterns to make smarter stocking decisions.",
    },
    {
      img: Img4,
      title: "Real-Time Seller Support",
      desc: "Chat directly with verified sellers for faster updates, product info, and smooth resolution—no middlemen.",
    },
  ];

  return (
    <section className="bg-white py-16 px-6 md:px-12">
      {/* Header */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          Supercharge Your Store, One Deal at a Time
        </h2>
        <p className="text-gray-600 mt-3 text-base md:text-lg">
          Explore unbeatable daily deals, seamless ordering, and tools that make
          bulk shopping smarter, faster, and more profitable.
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <div key={index} className="text-center">
            <img
              src={feature.img}
              alt={feature.title}
              className="w-full h-44 object-cover rounded-lg shadow-sm"
            />
            <h3 className="text-lg font-semibold text-gray-900 mt-4">
              {feature.title}
            </h3>
            <p className="text-gray-600 text-sm mt-2 leading-relaxed">
              {feature.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
